/**
 * Created by lihanying on 2017/7/6.
 */
import React from 'react'
import { Table, Button, Message } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import Modal from './modal'
import { DiscountText } from '../../../util'
import {
  fetchDelLevel,
  fetchLevelList,
  fetchEditLevel,
  fetchAddLevel,
} from '../../../api/setExpirationTime'
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      userInfo: {},
      action: '-1',
    }
  }

  // 编辑等级列表
  editLevel = async (permit) => {
    const { userInfo, action } = this.state
    let params = {
      clubId: sessionStorage.getItem('club_id'),
      id: userInfo.id,
      name: sessionStorage.getItem('name') || userInfo.name,
      discount:
        sessionStorage.getItem('discount') != null
          ? (sessionStorage.getItem('discount') / 10).toFixed(2)
          : (userInfo.discount / 10).toFixed(2),
      dayType: sessionStorage.getItem('dayType') || 1,
      number: sessionStorage.getItem('number') || 0,
      permit: permit,
    }
    const { data, detail, status } = await fetchEditLevel(params)
    if (status == 1) {
      Message.success('设置成功')
      window.location.reload()
    } else {
      Message.error(detail)
    }
  }

  // 新增等级列表
  addLevel = async (permit) => {
    const { userInfo, action } = this.state
    let params = {
      clubId: sessionStorage.getItem('club_id'),
      id: userInfo.id,
      name: sessionStorage.getItem('name') || userInfo.name,
      discount: (sessionStorage.getItem('discount') / 10).toFixed(2),
      dayType: sessionStorage.getItem('dayType') || 1,
      number: sessionStorage.getItem('number') || 0,
      permit: permit,
    }
    const { data, detail, status } = await fetchAddLevel(params)
    if (status == 1) {
      Message.success('新增成功')
      window.location.reload()
    } else {
      Message.error(detail)
    }
  }

  // 删除等级列表列表
  DeleteLevel = async (record) => {
    const { data, detail, status } = await fetchDelLevel({
      id: record.id,
      originType: 3,
    })
    if (status == 1) {
      Message.success('删除成功')
      window.location.reload()
    } else {
      Message.error(detail)
    }
  }

  onShowModal = (record) => {
    this.setState({ visible: true, userInfo: record, action: '1' })
  }

  handleOk = (params) => {
    const { userInfo, action } = this.state
    if (action === '-1') {
      //新增
      // let data = {
      //   club_id: sessionStorage.getItem('club_id'),
      //   name: sessionStorage.getItem('name'),
      //   discount: sessionStorage.getItem('discount'),
      //   level: 1, //0不可删除，1可删除
      //   permit: true, //权限
      //   dayType: sessionStorage.getItem('dayType'),
      //   number: sessionStorage.getItem('number'),
      // }
      // this.addLevel(permit)
      this.handleAddLevelOk(params)
    } else {
      //修改
      // let data = {
      //   club_id: sessionStorage.getItem('club_id'),
      //   id: userInfo.id,
      //   name: sessionStorage.getItem('name') || userInfo.name,
      //   discount: sessionStorage.getItem('discount') || userInfo.discount,
      //   dayType: sessionStorage.getItem('dayType'),
      //   number: sessionStorage.getItem('number'),
      // }
      // this.editLevel(permit)
      this.handleEditLevelOk(params)
    }

    this.setState({ visible: false, userInfo: {} }, () => this.clearSession())
  }

  clearSession = () => {
    sessionStorage.removeItem('name')
    sessionStorage.removeItem('discount')
    // sessionStorage.removeItem('dayType')
    // sessionStorage.removeItem('number')
  }

  handleCancel = () => {
    this.setState({ visible: false, userInfo: {} }, () => this.clearSession())
  }

  handleAddLevelOk = async (params) => {
    const { data, detail, status } = await fetchAddLevel(params)
    if (status == 1) {
      Message.success('操作成功')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    } else {
      Message.error(detail)
    }
  }

  handleEditLevelOk = async (params) => {
    const { data, detail, status } = await fetchEditLevel(params)
    if (status == 1) {
      Message.success('操作成功')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    } else {
      Message.error(detail)
    }
  }

  render() {
    const { list } = this.props
    const columns = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: '等级名称',
        dataIndex: 'discountFullName',
        key: 'discountFullName',
      },
      {
        title: '等级折扣',
        dataIndex: 'discount',
        key: 'discount',
        // render: (text) => {
        //   return DiscountText(text)
        // },
      },
      {
        title: '使用人数',
        dataIndex: 'usedCount',
        key: 'usedCount',
        render: (text, record, index) => {
          return (
            <a href={'/home/ClubMemberList?discountId=' + record.id}>{text}</a>
          )
        },
      },
      {
        title: '操作',
        dataIndex: 'edit',
        key: 'edit',
        render: (text, record, index) => {
          return (
            <div style={{ color: '#108EE9', cursor: 'default' }}>
              <Button type="primary" onClick={() => this.onShowModal(record)}>
                修改
              </Button>
              {record.level == 0 ? (
                <Popconfirm
                  title={`该等级属于默认等级,不能删除`}
                  okText="确认"
                  cancelText="取消"
                >
                  <Button type="primary" danger style={{ marginLeft: '20px' }}>
                    删除
                  </Button>
                </Popconfirm>
              ) : (
                <Popconfirm
                  title={`删除折扣后，使用当前折扣的会员会恢复成默认折扣，你确认要删除${record.name}等级吗?`}
                  okText="确认"
                  cancelText="取消"
                  onConfirm={() => this.DeleteLevel(record)}
                >
                  <Button type="primary" danger style={{ marginLeft: '20px' }}>
                    删除
                  </Button>
                </Popconfirm>
              )}
            </div>
          )
        },
      },
    ]

    return (
      <div>
        <div
          style={{
            marginBottom: '20px',
          }}
        >
          <Button
            type="primary"
            onClick={() => this.setState({ visible: true, action: '-1' })}
          >
            添加等级
          </Button>
        </div>
        <Table rowKey="id" bordered columns={columns} dataSource={list} />
        {this.state.visible && (
          <Modal
            {...this.state}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubLevel/component/level.js